export default __webpack_public_path__ + "static/media/ci5.2312d754.jpg";